const getSelectedPeriod = (filters, sortBy) => {
  const periodeFilter = filters.find(f => f.title === sortBy)
  if (!periodeFilter) return null
  const selectedItem = periodeFilter.items.find(item => item.value === true)
  return selectedItem ? selectedItem.name : null
}

export function createFilterChange(DataHandler, filtersRef, rawDataRef, sortBy, loadingRef, errorRef, errorMessageRef) {
  return async function filterChange($event) {
    const newFilters = $event.filters;

    if (filtersRef.value.length === 0) {
      filtersRef.value = JSON.parse(JSON.stringify(newFilters));
      return;
    }

    const oldPeriod = getSelectedPeriod(filtersRef.value, sortBy);
    const newPeriod = getSelectedPeriod(newFilters, sortBy);

    if (newPeriod !== oldPeriod && DataHandler) {
      try {
        loadingRef.value = true
        errorRef.value = false
        errorMessageRef.value = ''
        rawDataRef.value = []
        const periodKey = newPeriod.replace(/\s/g, "")
        const newData = await DataHandler(periodKey);
        rawDataRef.value = newData
      } catch (err) {
        errorRef.value = true
        errorMessageRef.value = err?.message || 'Filter data fetch failed.'
        rawDataRef.value = []
      } finally {
        loadingRef.value = false
      }
    }

    filtersRef.value = JSON.parse(JSON.stringify(newFilters));
  }
}
